customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('hp-product-carousel')) return;
  const NativeSlider = customElements.get('slider-component');

  customElements.define('hp-product-carousel', class extends NativeSlider {
    connectedCallback() {
      super.connectedCallback();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slider.addEventListener('keydown', event => {
        if (event.target.closest('input, select, textarea, [contenteditable="true"]')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const direction = document.dir === 'rtl' ? -1 : 1;
        const stride = Math.abs(this.sliderItemOffset || this.slider.clientWidth);
        let target = this.slider.scrollLeft + (event.key === 'ArrowLeft' ? -stride : stride);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = direction * (this.slider.scrollWidth - this.slider.clientWidth);
        this.slider.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.slider.addEventListener('focusin', event => {
        const card = event.target.closest('.slider__slide');
        if (card) card.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(() => this.initPages());
      this.observer.observe(this.slider);
    }

    updateNavButtons() {
      if (!this.prevButton || !this.nextButton) return;
      const maximum = this.slider.scrollWidth - this.slider.clientWidth;
      const position = Math.abs(this.slider.scrollLeft);
      this.prevButton.hidden = this.nextButton.hidden = maximum < 2;
      this.prevButton.disabled = position < 2;
      this.nextButton.disabled = position >= maximum - 2;
    }

    animateScrollTo(target, duration, easing, onComplete) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.slider.scrollTo({ left: target, behavior: 'instant' });
        if (onComplete) onComplete();
        return;
      }
      super.animateScrollTo(target, duration, easing, onComplete);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
});
